// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1d2Cc","row":"ProcedureTreatmentSummary_row__VhBIE"};